<div>
  <div class="buttonWrapper">
    <gl-radio-button
      name="rotateOnBase"
      [defaultChecked]="rotateOnBase"
      [ngModel]="rotateOnBase"
      (ngModelChange)="onRotateChange('rotateOnBase')"
      >
      {{ 'rotate_on_base' | translate }}
    </gl-radio-button>
    <gl-modal-hint class="info">
      <img class="infoImage" src="../../../../../assets/svg/rotateInfo.svg" />
      <p>
        {{ 'rotate_on_base_info' | translate }}
      </p>
    </gl-modal-hint>
  </div>

  @if (loadData?.loadType !== 2) {
    <div class="buttonWrapper">
      <gl-radio-button
        name="rotateFreely"
        [defaultChecked]="rotateFreely"
        [ngModel]="rotateFreely"
        (ngModelChange)="onRotateChange('rotateFreely')"
        >
        {{ 'rotate_freely' | translate }}
      </gl-radio-button>
      <gl-modal-hint class="info">
        <img class="infoImage" src="../../../../../assets/svg/rotateInfo.svg" />
        <p>
          {{ 'rotate_freely_info' | translate }}
        </p>
      </gl-modal-hint>
    </div>
  }

  <div class="buttonWrapper">
    <gl-radio-button
      name="allowToRotate"
      [defaultChecked]="allowToRotate"
      [ngModel]="allowToRotate"
      (ngModelChange)="onRotateChange('allowToRotate')"
      >
      {{ 'dont_allow_rotation' | translate }}
    </gl-radio-button>
    <gl-modal-hint class="info">
      <img class="infoImage" src="../../../../../assets/svg/rotateInfo.svg" />
      <p>
        {{ 'dont_allow_rotation_info' | translate }}
      </p>
    </gl-modal-hint>
  </div>
  @if (
    currentCargoSpace &&
    currentCargoSpace[0].trailerLoadingSide === 'back' &&
    currentCargoSpace[0].type === 1 &&
    !currentCargoSpace[1]
    ) {
    <div
      class="buttonWrapper"
      >
      <gl-checkbox
        [ngModel]="allowOutOfSpace"
        [defaultChecked]="allowOutOfSpace"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="onAllowOutOfSpaceChange()"
        >
        <div class="checkboxLabel">{{ 'allow_load_out_of_space' | translate }}</div>
      </gl-checkbox>
      <gl-modal-hint class="info">
        <p>
          {{ 'allow_load_out_of_space_info' | translate }}
        </p>
      </gl-modal-hint>
    </div>
  }
</div>
